import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import Pagination from "../../common/Pagination";
import * as actions from "../redux/VipListAction";
import { VipGameBalance } from "./VipGameBalance";

export const VipList = ({}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [swalProps, setSwalProps] = useState({});
  const [username, setUsername] = useState(
    searchParams.get("searchusername") ?? ""
  );
  const [pagenum, setPagenum] = useState(
    searchParams.get("pagenum") ? parseInt(searchParams.get("pagenum")) : 0
  );
  const [memberid, setMemberid] = useState();

  const vipListState = useSelector(({ vipList }) => vipList, shallowEqual);

  useEffect(() => {
    fetchVipList();
  }, []);

  const fetchVipList = (page) => {
    setPagenum(page ?? 0);
    setSearchParams({ searchusername: username, pagenum: page ?? 0 });
    dispatch(
      actions.fetchVipList({
        action: "memberviplist",
        searchusername: username,
        pagenum: page ?? 0,
      })
    );
  };

  return (
    <div>
      <div className="d-flex align-items-center">
        <h2>{intl.formatMessage({ id: "vipList" })}</h2>
      </div>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <VipGameBalance
        setMemberid={setMemberid}
        memberid={memberid}
        setSwalProps={setSwalProps}
      />
      <div className="d-flex align-items-center gap-2 mb-4">
        <input
          type="text"
          className="form-control flex-fill"
          placeholder={intl.formatMessage({ id: "username" })}
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              fetchVipList();
            }
          }}
        />
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => fetchVipList()}
        >
          {intl.formatMessage({ id: "search" })}
        </button>
      </div>
      <div
        className="mb-4 rounded d-flex align-items-center justify-content-spacebetween py-2 gamelistDiv1 cursor-pointer position-relative text-center mobile-overflow"
        style={{ border: "1px solid grey" }}
      >
        <table className="text-start table-report w-100">
          <tbody>
            <tr>
              <td className="col-3 ps-2">
                {intl.formatMessage({ id: "memberCount" })} :{" "}
                {vipListState.vipList?.totalmember}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        className="p-3 rounded"
        style={{ backgroundColor: "var(--table-background)" }}
      >
        <div className="table-responsive">
          <table className="custom-table">
            <thead>
              <tr>
                <th>{intl.formatMessage({ id: "no" })}</th>
                <th>{intl.formatMessage({ id: "username" })}</th>
                <th>{intl.formatMessage({ id: "nickname" })}</th>
                <th className="text-end">
                  {intl.formatMessage({ id: "vipBalance" })}
                </th>
                <th>{intl.formatMessage({ id: "vipLevel" })}</th>
                <th>{intl.formatMessage({ id: "memberCount" })}</th>
                <th>{intl.formatMessage({ id: "groupCount" })}</th>
                <th>{intl.formatMessage({ id: "action" })}</th>
              </tr>
            </thead>
            <tbody>
              {vipListState.vipList ? (
                vipListState.vipList.memberVipLevels.length > 0 ? (
                  vipListState.vipList?.memberVipLevels.map(
                    (memberVipLevel, index) => (
                      <tr key={memberVipLevel.memberid}>
                        <td>{pagenum * 10 + index + 1}</td>
                        <td>{memberVipLevel.username}</td>
                        <td>{memberVipLevel.nickname}</td>
                        <td className="text-end">
                          {memberVipLevel.vipbalance}
                        </td>
                        <td>{memberVipLevel.viplevel}</td>
                        <td>{memberVipLevel.membercount}</td>
                        <td>{memberVipLevel.groupcount}</td>
                        <td>
                          <button
                            className="btn btn-primary me-1"
                            style={{
                              backgroundColor: "#00FFFF",
                              borderColor: "#00FFFF",
                              color: "black",
                            }}
                            onClick={() => {
                              setMemberid(memberVipLevel.memberid);
                            }}
                          >
                            <i className="bi bi-exclamation-circle" />
                          </button>
                          <button
                            className="btn btn-primary me-1"
                            style={{
                              backgroundColor: "#00FF00",
                              borderColor: "#00FF00",
                              color: "black",
                            }}
                            onClick={() => {
                              navigate(memberVipLevel.memberid);
                            }}
                          >
                            <i className="bi bi-controller" />
                          </button>
                          <button
                            className="btn btn-primary me-1"
                            style={{
                              backgroundColor: "#0080FF",
                              borderColor: "#0080FF",
                              color: "white",
                            }}
                            onClick={() => {
                              navigate(
                                `downline/${memberVipLevel.memberid}/${memberVipLevel.username}`
                              );
                            }}
                          >
                            <i className="bi bi-info-circle" />
                          </button>
                        </td>
                      </tr>
                    )
                  )
                ) : (
                  <tr>
                    <td colSpan={8} className="text-center">
                      {intl.formatMessage({ id: "noRecordFound" })}
                    </td>
                  </tr>
                )
              ) : (
                <tr>
                  <td colSpan={8} className="text-center">
                    <div className="d-flex align-items-center justify-content-center">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          totalPages={parseInt(vipListState.vipList?.totalpage ?? "0")}
          currentPage={pagenum}
          onPageChange={(pageNumber) => {
            fetchVipList(pageNumber);
          }}
        />
      </div>
    </div>
  );
};
